export const ACCOUNT_ADMIN = "account_admin";
export const ACCOUNT_EMPLOYEE = "account_employee";
export const SEASONAL_WORKER = "seasonal_worker";
export const ASSIGNED_EMPLOYEE = "assigned_employee";
